import { useEffect } from "react";

import {
  REV_SHARE_CLASS,
  applyRevShareParams,
  resolveTpaBrandingParams,
} from "~/hec/utils/rev-share-params";

/**
 * Rev-share affiliate fallback listener (SFCC-11457).
 *
 * Appends TPA affiliate params (AFID/GroupName/CID, from the `tpaBranding`
 * cookie / URL) to external `.rev-share` anchors on click. This is the
 * GTM-less path: render it ONLY when Builder `gtmRevShare === false`. When GTM
 * owns rev-share this component is not mounted, so no listener is attached and
 * there is no risk of double-appending.
 *
 * One delegated listener on `document` (capture phase) covers Builder content
 * rendered after hydration and SPA navigation without re-binding. Capture runs
 * before the browser reads the href for default navigation (incl. _blank).
 * Note: left-click only — middle-click "open in new tab" fires `auxclick`, not
 * `click`, and is not rewritten (same click-based scope as the SFRA/GTM path).
 *
 * Renders nothing.
 */
export function RevShareLinkTracker() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest<HTMLAnchorElement>(`a.${REV_SHARE_CLASS}`);
      if (!anchor) return;
      applyRevShareParams(anchor, resolveTpaBrandingParams());
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
}
